module.exports = __webpack_public_path__ + "img/Asset113.4681c87d.png";